<template>
  <div v-if="regionData">
    <q-img
      class="cursor-pointer"
      :src="regionData.src"
      @click="gotoUrl"
    />
  </div>
</template>

<script>
export default {
  name: 'MoyaAdvertRegion',
  props: {
    regionId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      baseUrl: 'https://www.americanstyle.is/_/moya/adverts/region/show/',
      regionData: null,
    };
  },

  async created() {
    await this.fetchData();
  },

  methods: {
    async fetchData() {
      const response = await this.$axios(`${this.baseUrl}${this.regionId}`);
      if (response.status === 200) {
        this.regionData = response.data;
      }
    },

    gotoUrl() {
      if (this.regionData.url.indexOf('#') === -1) {
        window.open(this.regionData.url);
      }
      else {
        const url = this.regionData.url.substring(this.regionData.url.indexOf('#')).replace('#', '');
        this.$router.push(url);
      }
    },
  },
};
</script>

<style scoped>

</style>
